import Validity from './validity';

export default Validity;
